import toArray from "lodash/toArray";

import { Fragment } from "react";

import { useTranslator } from "@eo-locale/react";

import { Button, Flex, Progress, Stack, Text } from "@/storybook-components";
import { filterData } from "@/lib";
import { useAppSelector } from "@/redux/store/hooks";

import { TakenMessage } from "./gates";

interface ResponseProps {
  taken: boolean;
  onGoToForm: () => void;
}

const Response = ({ taken, onGoToForm }: ResponseProps): JSX.Element => {
  const { translate } = useTranslator();
  const { quickPoll, error, showThanks } = useAppSelector(
    (state) => state.quickPoll
  );

  if (error) return null;

  const { results, questionOptions, responsesCount } = quickPoll;
  const totalResponse =
    responsesCount ?? toArray(results).reduce((a, b) => a + b, 0);

  const data = filterData(questionOptions, { deleted: false }).map(
    (option) => ({
      id: option.id,
      label: option.name,
      value: totalResponse
        ? Math.round(((results[option.id] || 0) / totalResponse) * 100)
        : 0
    })
  );

  return (
    <Stack gap={2} className="ehq-quickPollResultContainer">
      {showThanks && <TakenMessage thanksMsg={quickPoll.thanksMsg} />}
      <Stack gap={0.5}>
        {data.map((d) => (
          <Fragment key={d.id}>
            <Text fontFamily="inherit" className="ehq-quickPollOption">
              {d.label}
            </Text>
            <Stack direction="row" align="center">
              <Progress
                width="100%"
                value={d.value}
                className="ehq-quickPollResultProgressBar"
              />
              <Text fontFamily="inherit" className="ehq-quickPollResultValue">
                {`${d.value}%`}
              </Text>
            </Stack>
          </Fragment>
        ))}
      </Stack>

      <Flex justify="space-between" align="center" width="100%">
        {quickPoll.state !== "archived" ? (
          <Button
            variant="link"
            className={
              taken
                ? "ehq-quickPollChangeVoteButton"
                : "ehq-quickPollBackToPollButton"
            }
            onClick={onGoToForm}
          >
            {translate(taken ? "quickPoll.changeVote" : "quickPoll.backToPoll")}
          </Button>
        ) : (
          <span />
        )}
        <Text fontFamily="inherit" className="ehq-quickPollTotalVotes">
          {translate("quickPoll.totalVotes", { count: totalResponse })}
        </Text>
      </Flex>
    </Stack>
  );
};

export default Response;
